document.addEventListener("DOMContentLoaded", () => {
	if (heroTitles && heroTitles.length > 0) {

	}
});
